import { connect } from 'react-redux';
import { IState } from '../../store/index';
import { IOfferAddedProps, OfferAdded } from './index';

function mapStateToProps(state: IState): IOfferAddedProps {
  return {
    added: state.offerData.offer.added || '',
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferAddedContainer = connect<IOfferAddedProps, any, any>(mapStateToProps)(OfferAdded);
